import React from 'react'
import { Modal, Spin } from 'antd';
import { getCategoryExperts,getRerouteUser, assigncategories } from '../../API/api';
import ExpDropdown from './ExpDropdown';
import Button from '../../NewComponent/Button/Button';
import { toast } from 'react-toastify';

export default function PrimaryExpert({isModalOpen,handleCancel}) {
  const [categoryExperts, setCategoryExperts] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [rerouteUser, setRerouteUser] = React.useState([]);
  const fetchCategoryExperts = async () => {
    setLoading(true);
    try {
      const response = await getCategoryExperts();
      if (response && response.data) {
        setCategoryExperts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching category experts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
// console.log("Category Experts:", categoryExperts);
//     handleCancel();
assigncategories(categoryExperts).then((res) => {
      if (res && res.data) {
        handleCancel();
        toast.success("Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }).catch((err) => {
      console.error("Error assigning categories:", err);
    })
  };
const fetchExperts = async () => {
    try {
      const response = await getRerouteUser();
      if (response && response.data) {
        response.data.data['users'].forEach((user) => {
          user.label = user.firstName + ' ' + user.lastName;
          user.value = user.label;
        });
        setRerouteUser(response.data.data['users']);
      }
    } catch (error) {
      console.error("Error fetching category experts:", error);
    } finally {
      // setLoading(false);
    }
  };
  React.useEffect(() => {
    if (isModalOpen) {
      fetchCategoryExperts();
      fetchExperts();
    }
  }, [isModalOpen]);
  return (
    <>
    <Modal
        title={
          <span style={{color:'#5C667B', fontSize:'17px', fontWeight:'400', lineHeight:'24px'}}>Assign Email Category to Primary Expert</span>}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Spin spinning={loading}  >
          {/* <div style={{width: '100%', padding: '20px'}}> */}
            {categoryExperts.length > 0 && (
            <div style={{ maxHeight: '400px', overflowY: 'auto',width: '100%', padding: '10px' }}>
              {categoryExperts.map((expert,index) => (
                <div key={index}>
                  <ExpDropdown expert={expert} rerouteUser={rerouteUser} category={rerouteUser} updateCategory={setCategoryExperts}/>
                </div>
                
              ))}
            </div>
          )}
          <div style={{ textAlign: 'center', marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
            <div><Button text={'Cancel'} type={'secondary'} onClickFunc={handleCancel}  /></div>&nbsp;&nbsp;
            <div><Button text={'Submit'} type={'primary'} onClickFunc={handleSubmit}  /></div>
          </div>
        </Spin>
      </Modal>
    </>
  )
}
